// extracted by mini-css-extract-plugin
export default {"card":"uicard_card__DhkJD","container":"uicard_container__6OxGQ"};